import { forEach } from 'lodash';
import { mouseTrap } from 'react-mousetrap';
import React from 'react';

export class KeyHandlerView extends React.Component {
    componentDidMount() {
        forEach(this.props.keys, (cb, key) => {
            this.props.bindShortcut(key, () => cb(this.props.children.props));
        });
    }

    componentWillUnmount() {
        forEach(this.props.keys, (cb, key) => {
            this.props.unbindShortcut(key);
        });
    }

    render() {
        return (
            <span>
                {this.props.children}
            </span>
        );
    }
}

export default mouseTrap(KeyHandlerView);
